import {actionTypes} from "./AuthActions";

export default function authReducer(state = {loggedIn: false, roles: [], username: ''}, action) {
    switch (action.type) {
        case actionTypes.LOAD:
            return {
                ...state, loggedIn: action.auth.loggedIn, roles: action.auth.roles, username: action.auth.username
            };
        case actionTypes.LOGOUT:
            return {...state, loggedIn: false, roles: ['ROLE_ANONYMOUS']};
        default:
            return {...state};
    }


}











// WEBPACK FOOTER //
// ./src/auth/AuthReducers.js